"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PersonEdit = function PersonEdit(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "person-edit",
    size: size
  }, _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M6 7.13V8H5v-.5l.6-.15.1-.04.14-.06.16-.12zM4 4c.13 0 .26.01.38.04l-.56.98A1 1 0 003 6v2H2V6c0-1.1.9-2 2-2zm1.9 1.4l-.56.98-.34.1V6a1 1 0 00-.23-.64l.52-.89a2 2 0 01.62.93zM4 0a2 2 0 011.98 2.25 1.5 1.5 0 00-.89.58L5 2.96l-.57 1A2 2 0 012 2c0-1.1.9-2 2-2zm0 1a1 1 0 100 2 1 1 0 000-2z"
  }), _react["default"].createElement("path", {
    fill: color,
    d: "M3.5 6.5a.5.5 0 010 1h-2a.5.5 0 010-1h2zm3.25-3.67a1 1 0 01.37 1.37l-1.4 2.42a.5.5 0 01-.23.2l-.07.03-1.17.32L3.94 6a.5.5 0 01.01-.3L4 5.61l1.4-2.42a1 1 0 011.36-.37zm-.93.62l.86.5a.5.5 0 10-.86-.5z"
  }));
};

PersonEdit.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = PersonEdit;
exports["default"] = _default;